import { StyleSheet } from 'react-native'
import theme from '../../../theme'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    image: {
        width: 120,
        height: 120,
        alignSelf: 'center',
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        paddingTop: 10,
        paddingHorizontal: 20,
    },
    description: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'left',
        paddingHorizontal: 20,
    },
    buttonContainer: {
        flexDirection: 'column',
        position: 'absolute',
        padding: 15,
        bottom: 15,
        width: '100%',
    },
    mainButton: {
        width: '100%',
        height: 40,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainButtonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    spacer: {
        height: 75,
    },
})

export default styles
